<!-- Hero Section -->
<div class="softwaredev-section-bg">
  <section class="softwaredev-section container py-5">
    <div class="glass-panel-container">
      <div class="row align-items-center">
        <div class="col-lg-5">
          <h1 class="softwaredev-heading mb-3">
            Tech Geek Ed. 1
          </h1>
          <!-- <h3 class="softwaredev-subheading2 mb-4">
            Discover the fresh stories of Kalpita Technologies.
          </h3> -->
          <div class="mb-5 contact-btn">
            <!-- <button class="btn case-study-btn me-3" (click)="goToCaseStudies()">
              Case Studies
            </button> -->
            <!-- <button class="btn hire-btn hire" (click)="exploreOurSolutions()">
              Explore Our Solutions
            </button> -->
          </div>
        </div>

        <div class="col-lg-7 text-center">
          <img src="../../../../assets/resources/techgeek/tech-geek-1-bannerimg.gif" alt="Tech Geek Edition1"
            class="img-fluid hero-image">
        </div>
      </div>
    </div>
  </section>
</div>
<!-- TL;DR Section with Image Icon -->
<section class="takeaways-section py-5">
  <div class="container">
    <h2 class="section-title text-center">TL;DR</h2>
    <div class="takeaways-list">
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
        <p>Tech Geek Magazine Edition 1 explores emerging technology trends across applications, research, and immersive
          devices shaping the future.</p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
        <p>The magazine highlights real-world app innovations using AR, AI, and digital platforms to simplify daily life
          and business operations.</p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
        <p>It showcases government-backed and enterprise-grade technologies, including ONDC and agritech solutions.</p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
        <p>Research & Development features focus on healthcare robotics, pollution control wearables, and automation
          concepts.</p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
        <p>A comparative analysis of VR, AR, and MR devices provides insights into next-generation immersive
          experiences.</p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
        <p>Overall, the edition serves as a technology trend compass for developers, businesses, and tech enthusiasts.
        </p>
      </div>
    </div>
  </div>
</section>
<!-- Key Takeaways Section with Image Icon -->
<section class="takeaways-section pt-0 pb-5">
  <div class="container">
    <h2 class="section-title text-center">Key Takeaways</h2>
    <div class="takeaways-list">
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
        <p><strong>Augmented Reality Apps: </strong>AR-powered apps like home design and virtual footwear trials
          enhance user decision-making through immersive, real-time visualization.</p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
        <p><strong>AI-Driven Creativity Platforms: </strong>AI image-generation tools and platforms demonstrate how
          human creativity can be amplified using prompt-based artificial intelligence.</p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
        <p><strong>ONDC & Digital Commerce Enablement: </strong>The government-owned ONDC ecosystem lowers entry
          barriers for businesses by enabling interoperable and scalable e-commerce participation.</p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
        <p><strong>Agritech & Farm Management Software: </strong>Digital farm management solutions empower farmers with
          data-driven insights to optimize productivity and operational efficiency.</p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
        <p><strong>Research and Development Innovations: </strong>Emerging inventions like anti-pollution helmets,
          robotic automation tools, and medical capsules reflect applied innovation solving real-world challenges.</p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
        <p><strong>VR / AR / MR Device Comparison: </strong>A detailed differentiation of immersive devices highlights
          evolving hardware capabilities, enterprise use cases, and future adoption potential.</p>
      </div>
    </div>
    <button class="btn case-study-btn" (click)="openModal()">
      Access Your Copy
    </button>
  </div>
</section>
<!-- Relevant Article -->
<app-relevant-techgeek></app-relevant-techgeek>

<!-- MODAL POPUP -->
<div class="modal-overlay" *ngIf="isModalOpen">
  <div class="modal-content-box">
    <button class="close-btn" (click)="closeModal()">&times;</button>

    <div class="modal-header" *ngIf="!submitSuccess">
      <h3>Access Your TechGeek Copy</h3>
      <p>Fill in your details to receive the Tech Geek Edition 1.</p>
    </div>

    <div *ngIf="submitSuccess" class="success-message text-center">
      <i class="ri-checkbox-circle-fill" style="color: #28a745; font-size: 3rem;"></i>
      <h4>Thank you!</h4>
      <p>Check your email for the download link.</p>
      <small style="color: #666;">Please check your spam folder if you don't see it.</small>
    </div>

    <form [formGroup]="downloadForm" (ngSubmit)="onSubmit()" *ngIf="!submitSuccess">
      <div class="form-group">
        <label>Full Name</label>
        <input type="text" formControlName="name" class="form-control" placeholder="Name">
        <div class="error-msg" *ngIf="downloadForm.get('name')?.touched && downloadForm.get('name')?.errors">

          <span *ngIf="downloadForm.get('name')?.errors?.['required']">
            Name is required
          </span>

          <span *ngIf="downloadForm.get('name')?.errors?.['pattern']">
            Name should contain only letters
          </span>

        </div>
      </div>

      <div class="form-group">
        <label>Email Address</label>
        <input type="email" formControlName="email" class="form-control" placeholder="Email">
        <div class="error-msg" *ngIf="downloadForm.get('email')?.touched && downloadForm.get('email')?.errors">

          <span *ngIf="downloadForm.get('email')?.errors?.['required']">
            Email is required
          </span>

          <span *ngIf="downloadForm.get('email')?.errors?.['pattern']">
            Enter a valid email address
          </span>

        </div>
      </div>

      <div class="alert alert-danger" *ngIf="errorMessage">{{ errorMessage }}</div>

      <div class="modal-footer">
        <button type="submit" class="submit-btn" [disabled]="isSubmitting">
          {{ isSubmitting ? 'Processing...' : 'Download Now' }}
        </button>
      </div>
    </form>
  </div>
</div>